// extracted by mini-css-extract-plugin
module.exports = {"listItem":"listItem__lO0A+","name":"name__1MWhI","badge":"badge__UpH8m"};